<template>
  <div>
    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="['search']"
          v-model="filter"
          :columns="columns"
          :msgs="'Name'"
        ></TableFilters>
      </v-card>

      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <v-row>
            <v-card-text class="pa-0 fo-101">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :fixed-header="true"
                :headers="headers"
                :items="smsservice"
                hide-default-footer
                item-key="name"
                class="row-pointer"
              >
                <template v-slot:no-data>
                  <noData
                    class="mt-10 container justify-center item-center"
                    name="SMS Service"
                  />
                </template>
                <!-- Status -->
                <template v-slot:item.created_at="{ item }">
                  {{ item.created_at | formatDate }}
                </template>

                <template v-slot:footer="{}">
                  <paginationComponent
                    @paginationOptions="setPaginationOptions"
                    url="sms-service"
                    :filter="filter"
                    :filterAction="true"
                    @getPageNumber="setPagenumber"
                    ref="pagination"
                    @response="receiveService"
                  />
                </template>
                <!-- Action -->

                <template v-slot:item.action="{ item }">
                  <v-icon large class="mr-2" @click="openConfirmation(item)">
                    mdi-message-bulleted
                  </v-icon>
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import confirmation from '../../modules/shared/components/confirmation.vue';
import TableFilters from '@/components/base/TableFilters';
import paginationComponent from '../shared/components/pagination.vue';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

import noData from '../../components/shared/noItem';
export default {
  data: () => ({
    paginationOptions: {},
    smsservice: [],
    columns: [
      {
        text: 'Send Date',
        value: 'created_at',
        show: true,
        disabled: false,
        width: '15%',
        align: 'center',
      },
      {
        text: 'Campaign',
        value: 'campaign',
        show: true,
        disabled: false,
        width: '15%',
        align: 'left',
      },
      {
        text: 'Phone Number',
        value: 'number',
        show: true,
        disabled: false,
        width: '15%',
        align: 'left',
      },
      {
        text: 'Message',
        value: 'message',
        show: true,
        disabled: false,
        width: '40%',
        align: 'center',
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        width: '5%',
        align: 'center',
      },
    ],
    filter: {
      search: '',
    },
  }),

  components: {
    ValidationProvider,
    ValidationObserver,
    paginationComponent,
    TableFilters,
    noData,
    confirmation,
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    clearFilter() {
      this.filter = {};
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    receiveService(roledata) {
      this.smsservice = roledata;
    },
    openConfirmation(number) {
      let bulkSMSData = {
        phoneNumber: number.number,
        message: number.message,
      };
      confirmation.dialog = true;
      this.$confirm('Do you want to re-send message ' + number.number).then(
        (res) => {
          if (res) {
            this.$store
              .dispatch('sms/SendSingleandBulkSMS', bulkSMSData)
              .then((res) => {
                if (res.data.message == 'Your SMS Notification is Disabled') {
                  this.$toast.error('Your SMS Notification is Disabled');
                } else {
                  this.$toast.success(res.data.message);
                }

                this.refreshData();
              })
              .catch((err) => {
                this.$toast.error('SMS notification not send');
              });
          } else {
          }
        },
      );
    },
  },
  computed: {
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
};
</script>

<style>
.fo-101 {
  font-weight: bold;
}
</style>
